import { useMemo } from "react";
import { getUserDetails } from "../utils/userDetailsUtils";

export const useModuleReadOnly = (moduleId, modules) => {
  const userType = getUserDetails()?.usertype;

  return useMemo(() => {
    if (userType === 1) return false;
    if (!moduleId || !Array.isArray(modules)) return false;

    const selectedModuleData = modules.find(
      (m) => String(m.idmodules) === String(moduleId),
    );

    return Boolean(
      selectedModuleData?.permissions?.some(
        (p) => String(p.roleid) === String(userType) && p.permission === "ReadOnly",
      ),
    );
  }, [moduleId, modules, userType]);
};

export default useModuleReadOnly;